import { Component, OnInit, ViewChild, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { AnalyticsService, isScoringEnabled, isCompletionEnabled, CourseAnalyticsTab, isQuizzEnabled } from '@shared/services/analytics.service';
import { Course } from '@shared/models';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { LoadState } from '@app/main/analytics/loader-directive/loader.module';
import { saveAs } from 'file-saver';
@Component({
  selector: 'visitors-stats',
  templateUrl: './visitors-stats.component.html',
  styleUrls: ['./visitors-stats.component.scss']
})
export class VisitorsStatsComponent implements OnInit, OnChanges {
  @Input() course: Course;
  @Input() date_from: Date;
  @Input() date_to: Date;
  @Input() search: string;
  @Output() onExplore = new EventEmitter<{ sessionId: string, userName: string }>();
  @Output() onSearch = new EventEmitter<{ name: string, tab?: CourseAnalyticsTab }>();
  public dataSource: MatTableDataSource<any>;
  public noData = false;
  public loadStatus: string;
  displayedColumns: string[];
  constructor(
    private _analyticsService: AnalyticsService,
  ) {

  }

  ngOnInit(): void {
    this.displayedColumns = ['actor_name', 'lastSessionDate', 'duration', 'sessionNumber'];
    if (isCompletionEnabled(this.course)) {
      this.displayedColumns.push('completed');
    }
    if (isScoringEnabled(this.course)) {
      this.displayedColumns.push('score');
    }
    if (isQuizzEnabled(this.course)) {
      this.displayedColumns.push('linkQuiz');
    }
    this.displayedColumns.push('linkSessions')
    this.loadVisitors();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if ((changes.date_from && !changes.date_from.isFirstChange() && changes.date_from.currentValue !== changes.date_from.previousValue)
      || (changes.date_to && !changes.date_to.isFirstChange() && changes.date_to.currentValue !== changes.date_to.previousValue)
      || (changes.search && changes.search.currentValue !== changes.search.previousValue)) {
      this.loadVisitors();
    }
  }

  loadVisitors() {
    this.loadStatus = LoadState.loading;
    this._analyticsService.getVisitors(this.course.id, { dateFrom: this.date_from, dateTo: this.date_to, userName: this.search }).subscribe(visitors => {
      this.loadStatus = LoadState.completed;
      if (!visitors || visitors.length === 0) {
        this.noData = true;
        this.dataSource = null;
        return;
      }
      // Get basic course visitors
      this.dataSource = new MatTableDataSource(visitors);
    }, () => {
      this.loadStatus = LoadState.error;
    });
  }
  goToDetails(session: any): void {
    this.onExplore.emit({ sessionId: session._id, userName: session.actor_name });
  }

  formatActor(name: string): string {
    if (name.indexOf('Anonymous') > -1) {
      return 'Anonymous';
    }
    return name;
  }
  formatScore(score: number): string {
    const xpMaxScore = this.course.information.ltiMaxScore;
    const readableScore = score || 0;
    return (xpMaxScore) ? `${readableScore}/${xpMaxScore}` : `${readableScore}`;
  }
  sortData(event: any): void {
    this.dataSource.data = this.dataSource.data.sort((a: any, b: any) => {
      const direction = event.direction === 'desc' ? -1 : 1;
      if(event.active === 'actor_name'){
        return a['actor_name'].localeCompare(b['actor_name']) * direction;
      }
      let sort = 0;
      if (a[event.active] > b[event.active]) {
        sort = 1;
      } else if (a[event.active] < b[event.active]) {
        sort = -1;
      }
      return sort * direction;
    });
  }
  isCompletionEnabled(): boolean {
    return isCompletionEnabled(this.course);
  }
  isScoringEnabled(): boolean {
    return isScoringEnabled(this.course);
  }
  isQuizzEnabled(): boolean {
    return isQuizzEnabled(this.course);
  }
  searchVisitors(userName: string) {
    this.onSearch.emit({ name: userName });
    this.search = userName;
    this.loadVisitors();
  }
  onSeeQuizResultClick(userName: string) {
    this.onSearch.emit({ name: userName, tab: CourseAnalyticsTab.Quizzes });
  }
  onSeeSessionsClick(userName: string) {
    this.onSearch.emit({ name: userName, tab: CourseAnalyticsTab.Sessions });
  }
  exportStats() {
    this._analyticsService.getVisitors(this.course.id, { dateFrom: this.date_from, dateTo: this.date_to, userName: this.search }, 'csv')
    .subscribe(data => {
      const fileName = `data_export_${this.course.title}_users_${new Date().toISOString().split('T')[0]}`;
      const blob = new Blob([data], {type: 'text/csv' })
      saveAs(blob, fileName);
    })
  }
}
